import { render, staticRenderFns } from "./PDPStickyCTAPricing.vue?vue&type=template&id=12908004&scoped=true"
import script from "./PDPStickyCTAPricing.vue?vue&type=script&lang=js"
export * from "./PDPStickyCTAPricing.vue?vue&type=script&lang=js"
import style0 from "./PDPStickyCTAPricing.vue?vue&type=style&index=0&id=12908004&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12908004",
  null
  
)

export default component.exports